export const BORDER_COLORS = {
    "a": "#ffff00",
    "b": "#ffff00",
    "c": "#cecece",
    "d": "#cecece",
    "e": "#ffff00",
    "f": "#ffff00",
    "g": "white",
    "h": "#ff0000",
    "i": "#ff0000",
    "j": "#cecece",
    "k": "#cecece",
    "l": "red",
    "m": "red",
    "n": "white",
    "o": "#1016cc",
    "p": "#1016cc",
    "q": "#cecece",
    "r": "#cecece",
    "s": "white",
    "t": "#cecece",
    "u": "#cecece",
    "v": "#cecece",
    "w": "#cecece",
    "x": "#cecece",
    "y": "#cecece",
    "z": "#cecece",
    "aa": "#ffff00",
    "bb": "#ffff00",
    "hh": "red",
    "ii": "red",
    "pa": "#cecece",
    "pb": "#cecece",
    "pc": "#cecece",
    "pd": "#cecece",
    "me": "#cecece",
    "mf": "#cecece",
    "mg": "#cecece",
    "mh": "#cecece",
    "gi": "#cecece",
    "gj": "#cecece",
    "gk": "#cecece",
    "gl": "#cecece",
    "bm": "#cecece",
    "bn": "#cecece",
    "bo": "#cecece",
    "bp": "#cecece",
    "nq": "#cecece",
    "nr": "#cecece",
    "ns": "#cecece",
    "nt": "#cecece",
    "fu": "#cecece",
    "fv": "#cecece",
    "fw": "#cecece",
    "fx": "#cecece",
    "ss": "blue",
    "tt": "blue",
    "uu": "wihte",
    "oo": "blue",
    "pp": "blue"
}